import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle, ListGroup, ListGroupItem } from 'reactstrap';
import { HasPermission } from '../../rbac/HasPermission';

/**
 * Permission-gated Quick-Links für die Dashboard-View.
 * Routes existieren als Placeholder (Phase 2 wird sie ersetzen).
 */
export function QuickLinks({ brandSlug }) {
  return (
    <Card className="h-100">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">
          Quick-Links
        </CardTitle>
        <ListGroup flush>
          <HasPermission perms={['audit.read']}>
            <ListGroupItem
              tag={Link}
              to={`/${brandSlug}/audit`}
              action
              className="d-flex justify-content-between align-items-center"
            >
              <span>📜 Audit-Log</span>
              <span className="text-muted small">letzte 24h</span>
            </ListGroupItem>
          </HasPermission>
          <HasPermission perms={['oss.read']}>
            <ListGroupItem
              tag={Link}
              to={`/${brandSlug}/oss`}
              action
              className="d-flex justify-content-between align-items-center"
            >
              <span>🇪🇺 OSS-Report</span>
              <span className="text-muted small">YTD-Schwelle</span>
            </ListGroupItem>
          </HasPermission>
          <HasPermission perms={['cancelIntents.read']}>
            <ListGroupItem
              tag={Link}
              to={`/${brandSlug}/cancel-intents`}
              action
              className="d-flex justify-content-between align-items-center"
            >
              <span>📤 Cancel-Intents</span>
              <span className="text-muted small">§ 312q</span>
            </ListGroupItem>
          </HasPermission>
          <HasPermission perms={['subscriptions.read']}>
            <ListGroupItem
              tag={Link}
              to={`/${brandSlug}/subscriptions`}
              action
              className="d-flex justify-content-between align-items-center"
            >
              <span>🔁 Subscriptions</span>
              <span className="text-muted small">past_due Filter</span>
            </ListGroupItem>
          </HasPermission>
        </ListGroup>
      </CardBody>
    </Card>
  );
}
